// Windows is the primary target; Mac only when detected.
export function isMacPlatform(): boolean {
  const platform = (navigator as any).userAgentData?.platform ?? navigator.platform ?? '';
  return /mac/i.test(platform);
}
